import React, { useState, useRef } from "react";
import Icon from "../Icon/Icon";
import "./CreateCommunicationModal.scss";

interface ICreateCommunicationModalProps {
  onClose: () => void;
  onSubmit: (data: { asunto: string; mensaje: string; files: File[] }) => void;
}

const CreateCommunicationModal: React.FC<ICreateCommunicationModalProps> = ({ onClose, onSubmit }) => {
  const [form, setForm] = useState({ subject: "", message: "" });
  const [files, setFiles] = useState<File[]>([]);
  const fileRef = useRef<HTMLInputElement>(null);

  const onAttach = () => fileRef.current?.click();

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const captured = Array.from(e.target.files);
      e.target.value = "";
      setFiles(prev => [...prev, ...captured]);
    }
  };

  const removeFile = (index: number) => {
    setFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ asunto: form.subject, mensaje: form.message, files });
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="create-comm-title" onClick={onClose}>
      <div className="comm-modal" onClick={(e) => e.stopPropagation()}>
        <button className="comm-modal__close" aria-label="Cerrar" onClick={onClose}>
          <Icon name="x" size={18} />
        </button>
        <header className="comm-modal__head">
          <div className="comm-modal__icon"><Icon name="chat" size={22} /></div>
          <h2 id="create-comm-title" className="comm-modal__title">Crear comunicación</h2>
          <p className="comm-modal__sub">Envíanos tu consulta y tu gestor te responderá lo antes posible.</p>
        </header>
        <form className="comm-form" onSubmit={handleSubmit}>
          <div className="field">
            <label className="field__label" htmlFor="cf-subject">Asunto</label>
            <input
              id="cf-subject"
              type="text"
              className="field__input"
              placeholder="Escribe un asunto claro y breve"
              value={form.subject}
              onChange={(e) => setForm({ ...form, subject: e.target.value })}
              required
            />
          </div>
          <div className="field">
            <label className="field__label" htmlFor="cf-message">Mensaje</label>
            <textarea
              id="cf-message"
              className="field__input field__textarea"
              placeholder="Escribe tu comentario..."
              rows={6}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              required
            />
            <div className="field__hint">
              <Icon name="info" size={13} /> Sé lo más específico posible para agilizar la respuesta.
            </div>
          </div>
          <input ref={fileRef} type="file" multiple accept=".jpg,.jpeg,.png,.gif,.pdf,.docx,.doc,.xlsx,.xls,.pptx,.ppt,.zip,.7z,.txt,.csv,.odt,.ods,.webp" style={{ display: "none" }} onChange={onFileChange} />
          {files.length > 0 && (
            <div className="comm-form__files">
              {files.map((f, i) => (
                <div key={i} className="comm-form__file">
                  <Icon name="file" size={16} />
                  <span className="comm-form__file-name">{f.name}</span>
                  <button type="button" className="comm-form__file-x" aria-label="Quitar archivo" onClick={() => removeFile(i)}>
                    <Icon name="x" size={14} />
                  </button>
                </div>
              ))}
            </div>
          )}
          <footer className="comm-modal__actions">
            <button type="button" className="btn btn--ghost btn--sm" onClick={onClose}>Cancelar</button>
            <button type="button" className="btn btn--secondary btn--sm" onClick={onAttach}>
              <Icon name="paperclip" size={16} /> Adjuntar archivos
            </button>
            <button type="submit" className="btn btn--primary btn--sm">
              Enviar <Icon name="arrow-right" size={16} />
            </button>
          </footer>
        </form>
      </div>
    </div>
  );
};

export default CreateCommunicationModal;
